// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jKtI","colBig":"styles_colBig__2zd6E","colSmall":"styles_colSmall__38VgO","shopifyNameWrapper":"styles_shopifyNameWrapper__3Nn54"};